(() => {
  const root = document.querySelector('[data-doopixel-gallery-product]');
  if (!root) return;
  const one = (selector) => root.querySelector(selector);
  const disableUnavailableDesign = () => {
    const button = one('.dp-gallery-product__form [type="submit"]');
    const message = one('[data-gallery-cart-message]');
    if (button) button.disabled = true;
    if (message) message.textContent = 'Design details are temporarily unavailable. Please contact us before ordering.';
  };
  const dataScript = one('[data-gallery-design-data]');
  let data;
  try {
    const raw = JSON.parse(dataScript?.textContent || 'null');
    data = typeof raw === 'string' ? JSON.parse(raw) : raw;
  } catch (_) {
    console.error('DooPixel product data could not be loaded.');
    disableUnavailableDesign();
    return;
  }
  if (!data || !Array.isArray(data.size) || data.size.length !== 2 ||
      !data.size.every((value) => Number.isFinite(Number(value)) && Number(value) > 0) ||
      !Array.isArray(data.parts) || !data.parts.length || !data.designId ||
      !Number.isFinite(Number(data.totalPieces)) || Number(data.totalPieces) <= 0) {
    console.error('DooPixel product data is missing or incomplete.');
    disableUnavailableDesign();
    return;
  }
  const format = (value) => Number(value).toLocaleString('en-US');
  one('[data-gallery-size]').textContent = `${data.size[0]} × ${data.size[1]} Pixels`;
  one('[data-gallery-type]').textContent = data.pieceTypeName || 'Pixel Pieces';
  one('[data-gallery-pieces]').textContent = format(data.totalPieces);
  one('[data-gallery-colors]').textContent = format(data.colorCount);
  one('[data-gallery-baseplates]').textContent = `${Math.ceil(data.size[0] / 16) * Math.ceil(data.size[1] / 16)} Baseplates (16 × 16 Each)`;
  one('[data-gallery-package-pieces]').textContent = `${format(data.totalPieces)} Pixel Pieces`;
  one('[data-gallery-design-id]').value = data.designId || '';

  const tbody = one('[data-gallery-parts]');
  for (const part of data.parts) {
    const row = document.createElement('tr');
    const number = document.createElement('td');
    const rawNumber = String(part.no || '');
    const cleanNumber = /^\d+$/.test(rawNumber) ? String(Number(rawNumber)) : rawNumber;
    number.textContent = part.type === '4073' && !cleanNumber.startsWith('A') ? `A${cleanNumber}` : cleanNumber;
    const color = document.createElement('td');
    const swatch = document.createElement('span');
    swatch.className = 'dp-gallery-product__swatch';
    if (/^#[a-f\d]{6}$/i.test(part.hex || '')) swatch.style.backgroundColor = part.hex;
    color.append(swatch, document.createTextNode(part.color || ''));
    const quantity = document.createElement('td');
    quantity.textContent = format(part.quantity);
    const type = document.createElement('td');
    type.textContent = part.type === '4073' ? 'Raised Pixel Pieces (4073)' : 'Flat Pixel Pieces (98138)';
    row.append(number, color, quantity, type);
    tbody.append(row);
  }

  const caption = one('[data-gallery-caption]');
  const variantSelect = one('[data-gallery-variant-select]');
  variantSelect?.addEventListener('change', () => {
    const price = one('.dp-gallery-detail__price');
    const selectedPrice = variantSelect.selectedOptions[0]?.dataset.price;
    if (price && selectedPrice) price.textContent = selectedPrice;
  });
  const toggle = one('[data-gallery-caption-toggle]');
  if (caption && toggle && caption.scrollHeight > caption.clientHeight + 4) {
    toggle.hidden = false;
    toggle.addEventListener('click', () => {
      const expanded = caption.classList.toggle('is-expanded');
      toggle.textContent = expanded ? 'Read Less' : 'Read More';
      toggle.setAttribute('aria-expanded', String(expanded));
    });
  }
  const mainImage = one('[data-gallery-main-image]');
  root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (mainImage) mainImage.src = thumb.dataset.imageUrl;
      root.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    });
  });
  const tableWrap = one('[data-gallery-table-scroll]');
  if (tableWrap) {
    const controls = [];
    const sync = () => {
      const max = Math.max(0, tableWrap.scrollWidth - tableWrap.clientWidth);
      tableWrap.classList.toggle('has-scroll-controls', max >= 2);
      for (const { bar, range, arrow } of controls) {
        bar.hidden = max < 2;
        range.value = max ? Math.round(tableWrap.scrollLeft / max * 1000) : 0;
        range.style.setProperty('--scroll-thumb', `${Math.max(32, tableWrap.clientWidth / tableWrap.scrollWidth * range.clientWidth)}px`);
        const atEnd = tableWrap.scrollLeft >= max - 2;
        arrow.textContent = atEnd ? '←' : '→';
        arrow.setAttribute('aria-label', atEnd ? 'Show Previous Columns' : 'Show More Columns');
      }
    };
    for (const position of ['top', 'bottom']) {
      const bar = document.createElement('div');
      bar.className = `dp-gallery-parts-scroll dp-gallery-parts-scroll--${position}`;
      const range = document.createElement('input');
      range.type = 'range';
      range.min = '0';
      range.max = '1000';
      range.setAttribute('aria-label', 'Scroll Parts Table Horizontally');
      const arrow = document.createElement('button');
      arrow.type = 'button';
      range.addEventListener('input', () => { tableWrap.scrollLeft = Number(range.value) / 1000 * (tableWrap.scrollWidth - tableWrap.clientWidth); sync(); });
      arrow.addEventListener('click', () => {
        const max = tableWrap.scrollWidth - tableWrap.clientWidth;
        tableWrap.scrollLeft = tableWrap.scrollLeft >= max - 2 ? 0 : Math.min(max, tableWrap.scrollLeft + tableWrap.clientWidth * .8);
        sync();
      });
      bar.append(range, arrow);
      tableWrap.insertAdjacentElement(position === 'top' ? 'beforebegin' : 'afterend', bar);
      controls.push({ bar, range, arrow });
    }
    tableWrap.addEventListener('scroll', sync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(tableWrap);
    else window.addEventListener('resize', sync);
    requestAnimationFrame(sync);
  }
  one('[data-gallery-copy-link]')?.addEventListener('click', async (event) => {
    try {
      await navigator.clipboard.writeText(location.href);
      event.currentTarget.textContent = 'Copied!';
    } catch (_) {
      event.currentTarget.textContent = 'Could Not Copy';
    }
  });
  const form = one('.dp-gallery-product__form');
  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const message = one('[data-gallery-cart-message]');
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding To Cart…';
    message.textContent = '';
    try {
      const variantId = Number(form.elements.namedItem('id')?.value);
      if (!Number.isSafeInteger(variantId) || variantId <= 0) {
        throw new Error('Please select a frame color before adding this kit.');
      }
      const properties = { '_DooPixel Design ID': data.designId };
      const legacyFrameSelect = form.elements.namedItem('properties[Frame Color]');
      if (legacyFrameSelect) properties['Frame Color'] = legacyFrameSelect.value;
      const cartResponse = await fetch(root.dataset.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties,
          }],
        }),
      });
      if (!cartResponse.ok) {
        const result = await cartResponse.json().catch(() => null);
        throw new Error(result?.description || 'Could Not Add This Kit To Cart.');
      }
      location.assign(root.dataset.cartUrl || '/cart');
    } catch (error) {
      message.textContent = error.message || 'Please try again.';
      button.textContent = originalLabel;
      button.disabled = false;
    }
  });
})();
